/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsIdQueryResponse,
  GetTeamsIdPathParams,
  GetTeamsId401,
  GetTeamsId404,
} from "../types/GetTeamsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsIdQueryKey = (
  id: GetTeamsIdPathParams["id"] | undefined,
) => [{ url: "/teams/:id", params: { id: id } }] as const;

export type GetTeamsIdQueryKey = ReturnType<typeof getTeamsIdQueryKey>;

/**
 * @summary Получение полной информации о команде по ID
 * {@link /teams/:id}
 */
export async function getTeamsId(
  id: GetTeamsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsIdQueryResponse,
    ResponseErrorConfig<GetTeamsId401 | GetTeamsId404>,
    unknown
  >({ method: "GET", url: `/teams/${id}`, ...requestConfig });
  return res;
}

export function getTeamsIdQueryOptions(
  id: GetTeamsIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsIdQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTeamsIdQueryResponse>,
    ResponseErrorConfig<GetTeamsId401 | GetTeamsId404>,
    ResponseConfig<GetTeamsIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsId(id!, { ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @summary Получение полной информации о команде по ID
 * {@link /teams/:id}
 */
export function useGetTeamsId<
  TData = ResponseConfig<GetTeamsIdQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsIdQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsIdQueryKey,
>(
  id: GetTeamsIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsIdQueryResponse>,
        ResponseErrorConfig<GetTeamsId401 | GetTeamsId404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getTeamsIdQueryKey(id);

  const query = useQuery(
    {
      ...getTeamsIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTeamsId401 | GetTeamsId404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
